import { render, staticRenderFns } from "./WorkflowItem.vue?vue&type=template&id=711d5aa2&scoped=true&"
import script from "./WorkflowItem.vue?vue&type=script&lang=js&"
export * from "./WorkflowItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711d5aa2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VIcon,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('711d5aa2')) {
      api.createRecord('711d5aa2', component.options)
    } else {
      api.reload('711d5aa2', component.options)
    }
    module.hot.accept("./WorkflowItem.vue?vue&type=template&id=711d5aa2&scoped=true&", function () {
      api.rerender('711d5aa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WorkflowItem.vue"
export default component.exports